import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values  = { url: String }

  connect() {
    this.poll()
  }

  disconnect() {
    this.stopPolling()
  }

  poll() {
    this.timer = setInterval(() => this.check(), 3000)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  async check() {
    try {
      const response = await fetch(this.urlValue)
      if (!response.ok) return

      const data = await response.json()

      if (!data.processing && data.results) {
        this.stopPolling()
        Turbo.visit(window.location.href)
      } else if (data.processing && data.progress) {
        this.containerTarget.innerHTML = this.progressHTML(data.progress)
      }
    } catch (e) {
      // Network error — keep trying
    }
  }

  progressHTML(p) {
    return `
      <div class="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mb-6">
        <div class="flex items-center gap-3">
          <svg class="animate-spin h-5 w-5 text-blue-400 shrink-0" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <div>
            <p class="text-sm font-medium text-blue-400">Processing import&hellip;</p>
            <p class="text-xs text-zinc-400 mt-0.5">
              ${p.current_row} rows &mdash; ${p.imported_count} imported, ${p.duplicate_count} duplicates, ${p.error_count} errors
            </p>
          </div>
        </div>
      </div>
    `
  }
}
